import React from "react"
import { notification } from "antd"
import api from "src/api"

import {getPaymentTypes, getPoints} from "../../../utils";

import { formatOrders } from "./order-table-data";

export function useGetOrders() {
  const [pagination, setPagination] = React.useState(null)
  const [appliedFilters, setAppliedFilters] = React.useState("")
  const [isLoading, setIsLoading] = React.useState(false)
  const [items, setItems] = React.useState([])
  const [deliveryTypes, setDeliveryTypes] = React.useState([])
  const [paymentTypes, setPaymentTypes] = React.useState([])
  const [points, setPoints] = React.useState([])

  async function getItems(page = 1, countOnPage = 20, filters = "") {
    setIsLoading(true)
    try {
      const response = await api.get(
        `orders?page=${page}&countOnPage=${countOnPage}${filters}`
      )
      setPagination({
        current: response.data.pagination.currentPage,
        pageSize: response.data.pagination.countOnPage,
        total: response.data.pagination.total,
      })
      setItems(response.data.items)

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  React.useEffect(() => {
    getItems()
    getDeliveryTypes()
    getDataPaymentTypes()
    getPoints().then((data) => setPoints(data ?? [])).catch(console.error)
  }, [])

  function handleTableChange(paginationData, _filters, _sorter, extra) {
    // AntD сортирует только загруженную страницу. Повторный запрос при клике
    // по заголовку сбрасывал бы страницу и не добавлял серверную сортировку.
    if (extra?.action === "sort") return
    getItems(paginationData.current, paginationData.pageSize, appliedFilters)
  }

  async function handlePaymentCheck(id) {
    setIsLoading(true)
    try {
      await api.get(`orders/payment/${id}`)
      notification.success({ message: `Оплата по заказу #${id} проверена` })

      getItems(pagination?.current ?? 1, pagination?.pageSize ?? 20, appliedFilters)

      setIsLoading(false)
    } catch (e) {
      console.error("Ошибка проверки оплаты", e)
      notification.error({
        message: `Ошибка проверки оплаты по заказу #${id}`,
        description: e?.response?.data?.message || undefined,
        duration: 8,
      })
      setIsLoading(false)
    }
  }

  async function resendToCrm(id) {
    setIsLoading(true)
    try {
      await api.get(`orders/send/${id}`)
      notification.success({ message: `Заказ #${id} отправлен в CRM/Tillypad` })

      getItems(pagination?.current ?? 1, pagination?.pageSize ?? 20, appliedFilters)

      setIsLoading(false)
    } catch (e) {
      console.error("Ошибка отправки заказа в CRM", e)
      notification.error({
        message: `Ошибка отправки заказа #${id} в CRM/Tillypad`,
        description: e?.response?.data?.message || undefined,
        duration: 8,
      })
      setIsLoading(false)
    }
  }

  function handleSearchTable(filters, paginationSet = null) {
    let filters_str = ""
    let count = 0

    for (const [key, rawValue] of Object.entries(filters)) {
      if (rawValue !== null && rawValue !== undefined && rawValue !== "") {
        const value = encodeURIComponent(rawValue)
        switch (key) {
          case "phone":
            filters_str += `&filters[${count}][t]=iL&filters[${count}][f]=user.phone&filters[${count}][v]=${value}`
            count++
            filters_str += `&filters[${count}][o]=orW&filters[${count}][t]=iL&filters[${count}][f]=guest_user_phone&filters[${count}][v]=${value}`
            break
          case "email":
            filters_str += `&filters[${count}][t]=iL&filters[${count}][f]=user.email&filters[${count}][v]=${value}`
            count++
            filters_str += `&filters[${count}][o]=orW&filters[${count}][t]=iL&filters[${count}][f]=guest_user_email&filters[${count}][v]=${value}`
            break
          case "innerId":
            filters_str += `&filters[${count}][t]=iL&filters[${count}][f]=inner_id&filters[${count}][v]=${value}`
            break
          case "totalPriceWithDiscount":
            filters_str += `&filters[${count}][t]=equal&filters[${count}][f]=total_price_with_discount&filters[${count}][v]=${value}`
            break
          case "dateFrom":
            filters_str += `&filters[${count}][t]=more&filters[${count}][f]=created_at&filters[${count}][v]=${value}`
            break
          case "dateTo":
            filters_str += `&filters[${count}][t]=less&filters[${count}][f]=created_at&filters[${count}][v]=${value}`
            break
        }
        count++
      }
    }

    setAppliedFilters(filters_str)

    if (paginationSet) {
      getItems(paginationSet.current, paginationSet.pageSize, filters_str)
    } else {
      getItems(1, pagination?.pageSize ?? 20, filters_str)
    }
  }

  function handleClearFilter() {
    setAppliedFilters("")
    getItems(1, pagination?.pageSize ?? 20)
  }

  async function getDataPaymentTypes() {
    const types = await getPaymentTypes()
    const newItems = types.map((item) => {
      return {
        label: item.name.find((el) => el.language === "ru").content,
        value: item.id
      }
    })
    setPaymentTypes(newItems)
  }
  async function getDeliveryTypes() {
    try {
      const { data } = await api.get("delivery-types")
      const options = data.items.map((item) => ({
        ...item,
        nameRu: item?.name?.find((el) => el.language === "ru").content,
      }))
      setDeliveryTypes(options)
    } catch (error) {
      console.error(error)
    }
  }

  return {
    items,
    pagination,
    isLoading,
    refetch: () => getItems(pagination?.current || 1, pagination?.pageSize || 20, appliedFilters),
    options: { deliveryTypes, paymentTypes, points },
    handleTableChange,
    handleSearchTable,
    handleClearFilter,
    handlePaymentCheck,
    resendToCrm
  }
}

export const getFormattedItems = formatOrders
